import { motion } from "framer-motion";
import { useScrollReset } from "utils";
import Dotcontianer from "./Components/Dotcontianer";
import Herosection from "./Components/Herosection";
import Ninedotleftref from "./Components/Ninedotleftref";
import Ninedotrightref from "./Components/Ninedotrightref";
import Perfomancesolution from "./Components/Perfomancesolution";
import Secondrefcontainer from "./Components/Secondrefcontainer";
import Thirdrefcontainer from "./Components/Thirdrefcontainer";
import Whychoosesection from "./Components/Whychoosesection";
import MobileScreen from "./MobileScreen";
import usePageHook from "./usePageHook";

const LaptopsScreen = () => {
  const { mainDivContinerRef } = usePageHook();
  useScrollReset();

  return (
    <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
      <div className="relative hidden lg:block">
        <div
          ref={mainDivContinerRef}
          className="relative w-screen h-screen overflow-hidden bg-black"
        >
          <Herosection />
          <Dotcontianer />
          <Ninedotleftref />
          <Ninedotrightref />
          <Perfomancesolution />
          <Whychoosesection />
          <Secondrefcontainer />
          <Thirdrefcontainer />
        </div>
      </div>
      <MobileScreen />
    </motion.div>
  );
};

export default LaptopsScreen;
